export function stickyHeader() {
  var observer = new IntersectionObserver(function(entries) {
    if(entries[0].intersectionRatio === 0) {
      $('header.header').addClass('header--sticky');
    } else if(entries[0].intersectionRatio === 1) {
      $('header.header').removeClass('header--sticky');
    }
  }, { threshold: [0,1] });
  observer.observe(document.querySelector('.hero .hero__observer'));
}
